import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';
import { Observable } from 'rxjs';
import { StyleContentMainSection } from 'src/app/shared/models/styleContent';

@Injectable({
  providedIn: 'root'
})
export class SectionMainService extends BaseService {

  private env = environment;

  constructor(
    http: HttpClient,
    errorHandlerService: ErrorHandlerService) {
    super(http, errorHandlerService);
  }

  getSectionMain(): Observable<StyleContentMainSection> {
    return this.get<StyleContentMainSection>(`${this.env.publicApiSocioUrl}v1/socio/main-section-configs`);
  }

}
